export default __webpack_public_path__ + "static/media/logo-spa.9a11b108.svg";